import React from 'react';
import TEXTS from '../controller/TextVariables';
import DropCheck from './DropCheck';
import { staticPOIList } from '../model/StaticVariables';
import { InterfaceContext } from '../model/InterfaceProvider';
import { StandardTooltipWindow } from './Tooltip';

export default function PointOfInterestUI() {
    const context = React.useContext(InterfaceContext);
    const { label, placeholder, tooltip } = TEXTS.controls.poi_select;

    const list = staticPOIList.map((poi) => {
        return Object.assign(poi, { selected: context[poi.slug] });
    });
    const onChange = (name, val) => {
        context.setToggle(name);
    };

    return (
        <div id="poi-select" className="field">
            <DropCheck label={label} placeholder={placeholder} list={list} onChange={onChange} tooltip={tooltip} tooltipPlace="left" />
        </div>
    );
}

const PointOfInterestUITooltip = () => {
    const { label, tooltip } = TEXTS.controls.poi_select;

    return <StandardTooltipWindow id={label} text={tooltip} />;
};

export { PointOfInterestUITooltip };
